import service from '@/utils/request';

// 获取菜单
export function getMenu(data) {
  return service({
    url: '/v1/menu/getMenu',
    method: 'get',
    params: data
  })
}

// 获取统计信息
export function getStatistic(data) {
  return service({
    url: '/v1/homepage/getStatistic',
    method: 'get',
    params: data
  })
}

// 作文提交概况
export function getStatisticByClass(data) {
  return service({
    url: '/v1/homepage/getStatisticByClass',
    method: 'get',
    params: data
  })
}

// 学生写作成长曲线
export function getScoreStatistic(data) {
  return service({
    url: '/v1/homepage/getScoreStatistic',
    method: 'get',
    params: data
  })
}


// 教师获取我创建的班级列表
export function getMyCreateClassList(data) {
  return service({
    url: '/v1/classInfo/getMyCreateClassList',
    method: 'get',
    params: data
  })
}

// 分页获取班级列表
export function getClassPageList(data) {
  return service({
    url: '/v1/classInfo/getPageList',
    method: 'post',
    data: data
  })
}

// 获取用户字典信息
export function getPageDict(data) {
  return service({
    url: '/v1/systemDict/getPageDict',
    method: 'post',
    data: data
  })
}


// 创建和编辑班级
export function saveOrUpdateClass(data) {
  return service({
    url: '/v1/classInfo/saveOrUpdate',
    method: 'post',
    data: data
  })
}


// 通过ID获取班级
export function getClassInfoById(data) {
  return service({
    url: '/v1/classInfo/getClassInfoById',
    method: 'get',
    params: data
  })
}

//解散班级
export function dismiss(data) {
  return service({
    url: '/v1/classInfo/dismiss',
    method: 'DELETE',
    params: data
  })
}


// 分页获取班级学员信息
export function getPageStudent(data) {
  return service({
    url: '/v1/classInfo/getPageStudent',
    method: 'post',
    data: data
  })
}

// 编辑学生
export function updateStudent(data) {
  return service({
    url: '/v1/classInfo/updateStudent',
    method: 'post',
    data: data
  })
}

// 删除学员
export function deleteStudent(data) {
  return service({
    url: '/v1/classInfo/deleteStudent',
    method: 'DELETE',
    params: data
  })
}


// 添加学生
export function addStudent(data) {
  return service({
    url: '/v1/classInfo/addStudent',
    method: 'POST',
    data: data
  })
}


// 教师端作业列表
export function getTaskList(data) {
  return service({
    url: '/v1/task/getPage',
    method: 'post',
    data: data
  })
}


// 任务列表
export function getAssignmentsList(data) {
  return service({
    url: '/v1/essay/assignmentsPage',
    method: 'post',
    data: data
  })
}

// 作业下的文章列表
export function getEssayssList(data) {
  return service({
    url: '/v1/essay/essaysPage',
    method: 'post',
    data: data
  })
}

// 学情列表
export function getStudyList(data) {
  return service({
    url: '/v1/studyStatistic/list',
    method: 'post',
    data: data
  })
}

//极速批改
export function getFastAssess(data) {
  return service({
    url: '/v1/essay/getFastAssess',
    method: 'post',
    data: data
  })
}

//根据id，获取文章信息
export function getEssayById(data) {
  return service({
    url: '/v1/essay/getEssayById',
    method: 'get',
    params: data
  })
}
//导出作文
export function exportTask(data) {
  return service({
    url: '/v1/essay/export',
    method: 'post',
    data: data,
  })
}


// 选择我创建的班级，学年、年级、班级三级级联选择
export function classTree(data) {
  return service({
    url: '/v1/studyStatistic/classTree',
    method: 'get',
    params: data,
  })
}


// 一个学生的所有报告
export function oneStudentAllReport(data) {
  return service({
    url: '/v1/studyStatistic/oneStudentAllReport',
    method: 'get',
    params: data,
  })
}


// 一个学生的学情报告
export function oneStudentStatistic(data) {
  return service({
    url: '/v1/studyStatistic/oneStudentStatistic',
    method: 'get',
    params: data,
  })
}


// 一个学生的历史提交明细列表
export function oneStudentUserTaskList(data) {
  return service({
    url: '/v1/studyStatistic/oneStudentUserTaskList',
    method: 'post',
    data: data,
  })
}
//学情默认班级
export function getMyNewestClassId(data) {
  return service({
    url: '/v1/classInfo/getMyNewestClassId',
    method: 'GET',
    parmas: data,
  })
}
//班级个数
export function getClassInfoCount(data) {
  return service({
    url: '/v1/classInfo/count',
    method: 'GET',
    parmas: data,
  })
}
